export const environment = {
    production: false,
    VERSION: require('../../package.json').version,
};
